import React, { Component } from 'react';
import Select from 'react-select'

// import Custom Componenets
import Breadcrumb from '../common/breadcrumb.component';
import BootstrapTable from 'react-bootstrap-table-next';
import Modal from 'react-responsive-modal';
import { Button, Form, FormGroup, Label, Col } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';

// koneksi
import { PostMain, GetMain, DeleteMain } from '../../function/Koneksi';

const formInput = {
	uuid: '',
	id_desa: '',
	nama_surat: '',
	keterangan: '',
	file: '',
	link_gambar: '',
	status: '',
  };

class RequestSurat extends Component {

	constructor(props) {
		super(props);
		this.state = {
			data: [],
			pagination: [],
			status: {
				form: false,
				btnForm: false,
				btnAksi: false,
				detail: false,
				edit: false,
			},
			awal: "",
			sebelum: "",
			hal: [],
			setelah: "",
			akhir: "",
			dt: formInput,
			judul: "Tambah Request Surat",
			alert: null,
			show: false,
			basicTitle: '',
			basicType: "default",
			pesanAlert: '',

			dataCari: '',
			loadingPreview: false,
			frmStatus: [],
			link_gambar: '',
      		fileSuratDesa: '',	
			
		};
	}

	// ================== Sweet Alert ==================
	closeAlert = () => {
		this.setState({
			show: false
		});
	}

	onRecieveInput = (value) => {
		this.setState({
			alert: (
				<SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
					You wrote: {value}
				</SweetAlert>
			)
		});
	}

	hideAlert = () => {
		this.setState({
			alert: null
		});
	}

	// ================== Ambil data dari db untuk table ==================
	fetch = (params = {}) => {
		this.setState({
			loadingPreview: true,
		})
		let link = "";
		
		if (params.page) {
			switch (params.page) {
				case ">>":
				  link =
					"?page=" +
					Math.ceil(
					  this.state.pagination.total / this.state.pagination.per_page
					);
				  break;
				case ">":
				  link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
				  break;
				case "<":
				  link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
				  break;
				case "<<":
				  link = "?page=1";
				  break;
				default:
				  link = "?page=" + params.page;
				  break;
			  }
		}

		let cari = "";
		if(params.page){
		  cari = '&q='+this.state.dataCari
		}
		else{
		  if(this.state.dataCari !== ""){
			cari = '?q='+this.state.dataCari
		  }
		}

		GetMain('main/web/request-surat' + link + cari, null, (lihat) => {
			if (lihat.results) {
				this.setState({ 
					data: lihat.results.data, 
					pagination: lihat.results,
					loadingPreview: false
				});
				this.pagination(lihat.results);
			}
			else{
				this.setState({ loadingPreview: false, });
			}
		});
	}

	// Pagination
	pagination = (data, tab) => {
		// const data = this.state.pagination;
		let awal = "";
		let hal = [];
		let sebelum = "";
		let setelah = "";
		let akhir = "";
		if (data.total > 0) {
		  let start = 1;
		  let end = 5;
		  let n = 0;
		  let p = 0;
		  if (data.current_page <= 3) {
			start = 1;
			end = 5;
			if (data.last_page > data.current_page) {
			  n = data.current_page + 1;
			}
		  } else {
			p = data.current_page - 1;
			n = data.current_page + 1;
			start = data.current_page - 2;
			end = data.current_page + 2;
		  }
		  if (end >= data.last_page - 2) {
			p = data.current_page - 1;
			if (start >= 5) {
			  start = data.last_page - 4;
			}
			end = data.last_page;
		  }
	
		  for (let i = start; i <= end; i++) {
			let warna = "success";
			if (i === data.current_page) {
			  warna = "danger";
			}
			hal.push(
			  <a
				href={() => false}
				key={i}
				onClick={() => this.fetch({ page: i, tab: tab })}
				className={
				  "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				}
			  >
				{i}
			  </a>
			);
		  }
		  if (p > 0) {
			sebelum = (
			  <a
				href={() => false}
				onClick={() => this.fetch({ page: p, tab: tab })}
				className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			  >
				{"<"}
			  </a>
			);
		  }
		  if (n > 0) {
			setelah = (
			  <a
				href={() => false}
				onClick={() => this.fetch({ page: n, tab: tab })}
				className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			  >
				{">"}
			  </a>
			);
		  }
	
		  awal = (
			<a
			  href={() => false}
			  onClick={() => this.fetch({ page: 1, tab: tab })}
			  className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			>
			  {"<<"}
			</a>
		  );
		  akhir = (
			<a
			  href={() => false}
			  onClick={() => this.fetch({ page: data.last_page, tab: tab })}
			  className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			>
			  {">>"}
			</a>
		  );
		}
	
		
		this.setState({ awal, sebelum, hal, setelah, akhir });
		
	};

	// Cari Data Table
	cariData = e => {
		if (e.key === 'Enter') {
			
			this.setState({ 
				dataCari: e.target.value,
			});

			setTimeout(
				function() {
					this.fetch();
				}.bind(this),
				500
			);
		}
	}

	// Making dynamic function
	handleInputChange = (e, fld) => {
		this.setState({
			dt:{
				...this.state.dt,
				[fld]: e.target.value
			}
		});
	};

	handleSelectChange = (e, data) => {
		if (e) {
			this.setState({ 
				dt:{
					...this.state.dt,
					[data]: { value: e.value, label: e.label }
				}
			});
		} else {
			this.setState({ 
				dt:{
					...this.state.dt,
					[data]: "",
				}
			});
		}
	}
	// Making dynamic function
	
	// ================== simpan data ==================

	simpan = e => {
		e.preventDefault();
		this.setState({ loadingPreview: true })
		
		if(this.state.link_gambar || (this.state.dt.uuid && this.state.dt.file)){
	
		  let add = {
			uuid: this.state.dt.uuid,
			id_desa: this.state.dt.id_desa,
			nama_surat: this.state.dt.nama_surat,
			keterangan: this.state.dt.keterangan,
			file: this.state.link_gambar,
			file_lama : this.state.dt.file,
			status: this.state.dt.status.value,
		  };
	  
		  let psn = "";
		  let resstat = 204;
		  let metode = "create";
		  if (add.uuid === "") {
			psn = "Tambah";
			resstat = 201;
			add.uuid = null;
		  } else {
			psn = "Ubah";
			resstat = 200;
			metode = "update";
		  }
			
		  PostMain("main/web/request-surat/" + metode, add.uuid, add, res => {
	  
			this.tutupForm();
			this.forceUpdate();
			
			if (res.status === resstat) {
			  this.setState({
				loadingPreview: false,
				show: true,
				basicType: "success",
				basicTitle: "Data Request Surat",
				pesanAlert: "Berhasil " + psn + " Data",
				dt: formInput,
				  status: {
					...this.state.status,
					form: false
				  }
			  });
			} else {
			  this.setState({
				loadingPreview: false,
				show: true,
				basicType: "danger",
				basicTitle: "Data Request Surat",
				pesanAlert: "Gagal " + psn + " Data"
			  });
			}
			this.componentDidMount();
		  });
	
		}
		else{
		  this.setState({
			loadingPreview: false,
			show: true,
			basicType: "danger",
			basicTitle: "Data Request Surat",
			pesanAlert: "Data Tidak Lengkap"
		  });
		}
	};

	ubahData = data => {
		this.setState({
			judul: "Ubah Data Request Desa ",
			loadingPreview: true,
		});

		if (data) {
			this.setState({
				link_gambar: JSON.parse(data.file),
				dt: {
					uuid: data.uuid,
					id_desa: data.id_desa,
					nama_surat : data.nama_surat,
					keterangan : data.keterangan,
					file : JSON.parse(data.file),
					status : { value: data.status, label: data.status },
				},
				status: {
					...this.state.status,
					form: true,
					edit: true,
				},
				loadingPreview: false,
			})
		}
		else{
			this.setState({
				loadingPreview: false,
			})
		}
	};

	konfirmHapus = (id) => {
		this.setState({
			alert: (
				<SweetAlert
					showCancel
					confirmBtnText="Hapus"
					confirmBtnBsStyle="danger"
					cancelBtnBsStyle="success"
					type="danger"
					title="Yakin ingin hapus data ?"
					onCancel={this.hideAlert}
					onConfirm={() => this.hapusData(id)}
				>
					Proses ini tidak dapat dibatalkan!
				</SweetAlert>
			)
		});
	}

	hapusData = (id) => {
		this.hideAlert();
		let psn = "Hapus";
		this.setState({
			loadingPreview: true
		})
		DeleteMain('main/web/request-surat/delete', id, (res) => {
			if (res === 200) {
				this.setState({ 
					loadingPreview: false,
					show: true, 
					basicType: 'success', 
					basicTitle: 'Data Request Surat', 
					pesanAlert: 'Berhasil ' + psn + ' Data' 
				});
			}
			else {
				this.setState({ 
					loadingPreview: false, 
					show: true, 
					basicType: 'danger', 
					basicTitle: 'Data Request Surat', 
					pesanAlert: 'Gagal ' + psn + ' Data' 
				});
			}
			this.componentDidMount();
		})
	}

	bukaForm = (e) => {
		if (e === 'tambah') {
			this.setState({
				dt:formInput,
			})
		}

		this.setState({
			status: {
				...this.state.status,
				form: true,
			}
		})
	}

	tutupForm = () => {
		this.setState({
			status: {
				form: false,
				btnForm: false,
				btnAksi: false,
				detail: false,
				edit: false,
			},
			dt: formInput,
		})
		this.forceUpdate();
	}

	getFilePreview = (data) => {
			
		const fileParse = data.file;
		// const imageUrl = fileParse.thumbnail;
		const fileUrl = fileParse.url;
		const fileName = fileParse.filename;
		const fileExtension = fileName.split('.').pop().toLowerCase();
	
		switch (fileExtension) {
			case 'png':
			case 'jpg':
			case 'jpeg':
		  	case 'pdf':
			case 'xlsx':
			case 'xls':
			case 'doc':
			case 'docx':
			return <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary">Download File</a>;
		  
			default:
				return (
				<div>
					<p>Format file ini tidak didukung. Silahkan di Download <a href={fileUrl}>Download</a>.</p>
				</div>
			);
		}
	}

	tombolAksi = (cell, row) => {
		let btnAksi = false;

		if (row.status === 'Selesai' || row.status === 'Ditolak') {
			btnAksi = true;
		} else {
			btnAksi = false;
		}
		return (
			<>
				<Button size="xs" color="success" className="btn-icon mr-1" onClick={() => this.ubahData(row)} disabled={btnAksi}><i className="fa fa-pencil"></i></Button> &nbsp;&nbsp;
			</>
		)
	}

	componentDidMount() {
		this.fetch({ page: null, where: [] });

		// ======================= Select Enum Status Request Surat ==========================

		GetMain('master/select-enum-main/request_surat/status', null, (data) => {
			if (data) {	
				let frmStatus = [];

				data.forEach(dt => {
					frmStatus.push({ value: dt, label: dt });
				});
				this.setState({ frmStatus });
			}
		});
	}
	
	render() {

		var data = this.state.data;

		const columns = [
			{
				dataField: "no",
				text: "No",
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
				align: 'center',
				formatter: (key, obj, index) =>{          
					let current_pagenum = this.state.pagination.current_page;
					let total_records_per_page = this.state.pagination.per_page;
					let row_index = (index+1);
					let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
					return serial_num; 
				}
			},
			{
				dataField: 'nama_surat',
				text: 'Nama',
				headerAlign: 'center',
				sort: true
			},
			{
				dataField: 'keterangan',
				text: 'Keterangan',
				headerAlign: 'center',
				sort: true
			},
			{
				dataField: 'status',
				text: 'Status',
				headerAlign: 'center',
				align: 'center',
				sort: true
			},			
			{
				dataField: 'aksi',
				text: 'Aksi',
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
				align: 'center',
				formatter: this.tombolAksi,
			},
		];

		return (
			<div>
				<Breadcrumb title="Request Surat" parent="Admin" />
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>

				{this.state.alert}

				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-12">
							<div className="card mb-0">
								<div className="card-body datatable-react">
									<div className="row">
										<div className="col-sm-6">
											<input
												type="search"
												className="form-control"
												id="cariTable"
												placeholder="Cari Disini..."
												defaultValue={this.state.dataCari}
												onKeyPress={this.cariData}
											/>
										</div>
									</div>

									<BootstrapTable
										keyField="uuid"
										data={data}
										columns={columns}
									/>
									<div className="pull-right text-white">
										{this.state.awal}
										{this.state.sebelum}
										{this.state.hal.map((dt) => {
											return dt;
										})}
										{this.state.setelah}
										{this.state.akhir}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<br />
				{/* Loading preview */}
				<SweetAlert
					show={this.state.loadingPreview}
					showCancel = {false}
					showConfirm={false}
				>
					<div align="center">
						<h5 className="modal-title" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5>
						<br/>
						<img 
							alt="loading"
							src={require("../../assets/images/tes-loading.gif")} 
							style={{
								// width: "100%",
								borderRadius: "10px",
								width: '150px'
							}}
						/> 
						<br/><br/>
					</div>
				</SweetAlert>
				
				<Modal styles={{ modal: { width: "70%" } }} open={this.state.status.form} onClose={this.tutupForm} closeOnEsc={false} closeOnOverlayClick={false}>
					<Form className="theme-form" onSubmit={this.simpan}>
						<div className="modal-header">
							<h5 className="modal-title">{this.state.judul}</h5>
						</div>
						<div className="modal-body">
							<input className="form-control" id="uuid" type="hidden" placeholder="UUID" defaultValue={this.state.dt.uuid} />
							<input className="form-control" id="id_desa" type="hidden" placeholder="Id Desa" defaultValue={this.state.dt.id_desa} />

							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Nama Surat</Label>
								<Col sm='9'>
									<input 
										className="form-control" 
										id="nama_surat" 
										type="text" 
										placeholder="Contoh: Surat Keterangan Kurang Mampu" 
										defaultValue={this.state.dt.nama_surat} 
										onChange={e => this.handleInputChange(e, "nama_surat")}
										readOnly={this.state.status.edit?true:false}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
								>
								File
								</Label>
								<Col sm="9">
								{this.state.dt.file ? (
									<div>
										{this.getFilePreview(this.state.dt)}
									</div>
								) : (
									""
								)}
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Status Surat</Label>
								<Col sm='9'>
									<Select
										classNamePrefix="select"
										onChange={e => { this.handleSelectChange(e,"status")}}
										value={this.state.dt.status}
										name="status"
										options={this.state.frmStatus}
										placeholder="Pilih Status Request Surat"
										isClearable
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Keterangan</Label>
								<Col sm='9'>
									<textarea 
										className="form-control" 
										id="keterangan" 
										type="text" 
										placeholder="Silahkan Masukkan Keterangan Tentang Surat" 
										defaultValue={this.state.dt.keterangan} 
										onChange={e => this.handleInputChange(e, "keterangan")}
										required={this.state.dt.status && this.state.dt.status.value === 'Ditolak'}
										readOnly={this.state.dt.status && this.state.dt.status.value !== 'Ditolak'}
									/>
								</Col>
							</FormGroup>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-warning" disabled={this.state.status.btnForm} onClick={this.tutupForm}>Tutup</button>
							{
								this.state.status.detail?
								<></>
								:
								<button type="submit" className="btn btn-success" disabled={this.state.status.btnForm} onClick={this.simpan}>Simpan</button>
							}
						</div>
					</Form>
				</Modal>
			</div>
		)
	}
}


export default RequestSurat;
